import React from "react";
import style from "./about.module.scss";
import Card from "../../commons/cardIcon/Card";
import datos from "../../data/datos";
import { AnimationOnScroll } from "react-animation-on-scroll";

function AboutComponent({ items }) {
  return (
    <div className={style.abContainer}>
      <div className={style.container}>
        <div className={style.aboutMe}>
          <h2>
            <span className={style.subrayado}>ACERCA D</span>E MÍ
          </h2>
        </div>
        <div className={style.aboutContainer}>
          <AnimationOnScroll
            className={style.parrafoContainer}
            animateIn="animate__backInLeft"
            animateOnce={true}
            duration={2.2}
          >
            <div>
              <h4>QUIEN SOY</h4>
            </div>
            <p>
              Hola! Soy Lean, programador fullstack en Java Script. Soy una
              persona honesta, comprometida y entusiasta por aprender
              constantemente. Me destaco por mi capacidad para trabajar en
              equipo y por adaptarme a diferentes entornos laborales. Mis años
              en la carrera de ingeniería y mi amplia experiencia laboral, me
              han brindado herramientas para administrar eficientemente recursos
              y procesos, solucionar problemas y mejorar continuamente. Me
              considero una persona proactiva, enfocada en explotar al máximo
              mis habilidades y trabajar con dedicación en mis punto débiles
              para ser una mejor persona y un excelente profesional.
              Actualmente, participo en distintos proyectos freelance. En mis
              tiempos libres me gusta seguir capacitandome y jugar paddle.
            </p>
          </AnimationOnScroll>
          <AnimationOnScroll
            className={style.cardsContainer}
            animateIn="animate__backInRight"
            animateOnce={true}
            duration={2.2}
          >
            <div className={style.divTitle}>
              <h4>HERRAMIENTAS</h4>
            </div>
            <div className={style.grilla}>
              {datos.map((dato, i) => (
                <Card key={i} items={dato} />
              ))}
            </div>
          </AnimationOnScroll>
        </div>
      </div>
      <div style={{ lineHeight: 0 }}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path
            fill="#e8e8e8"
            fillOpacity="1"
            d="M0,160L48,170.7C96,181,192,203,288,213.3C384,224,480,224,576,218.7C672,213,768,203,864,213.3C960,224,1056,256,1152,250.7C1248,245,1344,203,1392,181.3L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          ></path>
        </svg>
      </div>
    </div>
  );
}

export default AboutComponent;
